export default __webpack_public_path__ + "static/media/Custom-HUD-Targeting (Reticle, 1L, 3D).6bdaacff.jpg";